(function (upp, angular) {
    'use strict';

    //Controller for template "/plugins/products/eshop-promotions-products-catalog.html", url "/eshop/" or "/promotions"
    upp.controller('upp.plugins.products.CatalogCtrl', ['$scope', 'appi', '$injector', 'catalogFiltersService',
        function ($scope, appi, $injector, catalogFiltersService) {
            if (typeof $scope.listProducts === 'function') {
                var calculateIfThereIsMore,
                    currentPage = 1;

                /**
                 * Retrieve filters and set initial scope
                 */
                var init = function () {
                    var filters = catalogFiltersService.get();
                    $scope.filters = {};

                    if (filters) {
                        if (filters.text) {
                            $scope.filters.name = filters.text;
                        }

                        if (filters.order) {
                            $scope.filters.order = filters.order;
                        }

                        if (filters.category) {
                            $scope.filters.category = {
                                id: Number(filters.category)
                            };
                        }

                        if (filters.subcategory) {
                            $scope.filters.subcategory = {
                                id: Number(filters.subcategory)
                            };
                        }
                    }

                    requestProducts();
                };

                /**
                 * save the filters in the internal storage.
                 * So we can load again when the user reconnect.
                 */
                var storeFilters = function() {
                    var category = null, subcategory = null, order = null, text = null;

                    if ($scope.filters) {
                        if ($scope.filters.category) {
                            category = $scope.filters.category.id;
                        }

                        if ($scope.filters.subcategory) {
                            subcategory = $scope.filters.subcategory.id;
                        }

                        if ($scope.filters.name) {
                            text = $scope.filters.name || '';
                        }

                        if ($scope.filters.order) {
                            order = $scope.filters.order;
                        }
                    }

                    catalogFiltersService.set(category, subcategory, order, text);
                };

                /**
                 * get the filters and set as params for the request
                 * @param data
                 */
                var _setRequestProductsParams =  function(data){
                    if ($scope.filters.order >= 0) {
                        data.order = $scope.filters.order;
                    }

                    if ($scope.filters.name) {
                        data.search = $scope.filters.name;
                    }

                    if ($scope.filters.category && $scope.filters.category.id > 0) {
                        data.filter.categoryId = $scope.filters.category.id;
                    }

                    if ($scope.filters.subcategory && $scope.filters.subcategory.id > 0) {
                        data.filter.categoryId = $scope.filters.subcategory.id;
                    }
                };


                /**
                 * Load products with the actual filters
                 */
                var requestProducts = function () {

                    storeFilters();

                    $scope.more = true;
                    $scope.busy = true;
                    appi.ui.showPageLoadingMsg();

                    var data = {
                        filter: {}
                    };

                    _setRequestProductsParams(data);

                    $scope.listProducts(data)
                        .then(function (data) {
                            $scope.products = data.products;
                            $scope.currency = data.currency;
                            $scope.loaded = true;
                            $scope.busy = false;
                            appi.ui.hidePageLoadingMsg();
                            calculateIfThereIsMore && calculateIfThereIsMore(data.products.length, data.request);
                        }, function () {
                            appi.ui.showNetworkError();
                        });
                };


                $scope.filterProducts = requestProducts;

                if ($scope.infiniteScroll) {
                    /**
                     * Calculates and set in the scope if there ara more available elements with the info provided by the server
                     * @param {Integer} productsCount
                     * @param {Object} queryReport
                     */
                    calculateIfThereIsMore = function (productsCount, queryReport) {
                        $scope.more = (productsCount > 0) && (Number(queryReport.total) > Number(queryReport.currentPage) * Number(queryReport.maxRows));
                    };

                    /**
                     * Requests more elements if possible(after first load and if there are more available elements)
                     * to the service (used with infinite scroll) and publish them in the scope
                     *
                     * @method retrieveMoreProducts
                     *
                     */
                    $scope.retrieveMoreProducts = function () {
                        if ($scope.loaded && $scope.more) {
                            $scope.busy = true;

                            var data = {
                                pagination: {
                                    page: ++currentPage
                                },
                                filter: {}
                            };

                            _setRequestProductsParams(data);

                            $scope.listProducts(data)
                                .then(function (data) {
                                    $scope.busy = false;
                                    angular.forEach(data.products, function (product) {
                                        $scope.products.push(product);
                                    });
                                    calculateIfThereIsMore(data.products.length, data.request);
                                });
                        }
                    };
                }

                /**
                 * Call cartService to add a product
                 *
                 * @method add2cart
                 * @param {Object} product
                 */
                $scope.add2cart = function (product) {
                    var cartService = $injector.get('cartService');
                    cartService.add(product, $scope.currency);
                };

                /**
                 * check if all the products have price or not
                 * @returns {boolean}
                 */
                $scope.allProductsProductsHavePrice = function () {
                    if ($scope.products) {
                        var totalPrice = 0;
                        for (var i = 0, len = $scope.products.length; i < len; i++) {
                            totalPrice += $scope.products[i].price;
                        }

                        return totalPrice > 0;
                    }

                    return false;
                };

                /**
                 * Does the catalog have any filter?
                 * @returns {boolean}
                 */
                $scope.catalogHasFilters = function () {
                    return $scope.filters && (
                            ($scope.filters.category && $scope.filters.category.id > 0) ||
                            ($scope.filters.subcategory && $scope.filters.subcategory.id > 0) ||
                            ($scope.filters.name && $scope.filters.name.length > 0) ||
                            $scope.filters.order > -1);
                };

                // load
                init();

            } else {
                throw new Error("'listProducts' function not defined");
            }
        }]);

})(upp, angular);



// WEBPACK FOOTER //
// ./src/app/plugins/products/controllers/products-controllers.js